import { render } from "./ManageAllPage.vue?vue&type=template&id=578043c3&ts=true"
import script from "./ManageAllPage.vue?vue&type=script&lang=ts"
export * from "./ManageAllPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__